<template>
    <v-dialog v-model="show" max-width="390" persistent no-click-animation>
        <v-card>
            <v-card-title primary-title class="headline grey lighten-2 pa-0">
                <v-layout row justify-space-between align-center>
                    <div class="ml-3">{{$t('language') | capitalize}}</div>
                    <v-btn flat icon @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-list>
                    <v-list-tile
                        v-for="lang in langs"
                        v-bind:key="lang.lang"
                        v-on:click="changeLanguage(lang.lang)"
                        active-class="language-active"
                        :class="lang.lang=== $i18n.locale? 'language-active': ''"
                    >
                        <v-list-tile-avatar size="21" class="icon-language">
                            <img :src="lang.icon"/>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title class="language-text">{{lang.name}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "LanguageMenu",
    data () {
        return {
            langs: [
                {
                    lang: "en-US",
                    name: "English",
                    icon: require("assets/icons/en-ico.svg")
                },
                {
                    lang: "vi-VN",
                    name: "Việt Nam",
                    icon: require("assets/icons/vi-ico.svg")
                },
                // {
                //   lang: "ja-JP",
                //   name: "Japanese",
                //   icon: require("assets/icons/ja-ico.svg")
                // }
            ],
            show: false
        };
    },
    methods: {
        changeLanguage (lang) {
            localStorage.setItem('locale', lang);
            this.$i18n.locale = lang;
            this.close()
        },
        open () {
            this.show = true
        },
        close () {
            this.show = false
        }
    }
};
</script>

<style scoped>
.icon-language {
    min-width: 21px !important;
    padding-right: 6px;
}

.language-text {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;

    /* #7C7C7C */

    color: #7c7c7c;
}

.language-active {
    background: #eaeaea;
    box-shadow: 0px 1px 0px #e5e5e5;
}
</style>
